// This file is auto-generated from .env files
// DO NOT edit this file directly. Update .env files instead.
// Generated at: 2026-10-27T12:13:38.935Z
// Source: .env.local

export const environment = {
  production: false,
  enableLogs: false,
  demoRealm: false,
  demoUserPassword: "Demo@SuperSee2026!",
  demoAgent: {
    windowsDownloadUrl: ""
  },
  firebase: {
    apiKey: "AIzaSyANTfsTb7aqki9PC0JnsNdUg-Fu2od4fK8",
    authDomain: "supersee-d8e59.firebaseapp.com",
    databaseURL: "https://supersee-d8e59-default-rtdb.firebaseio.com",
    projectId: "supersee-d8e59",
    storageBucket: "supersee-d8e59.firebasestorage.app",
    messagingSenderId: "896472724309",
    appId: "1:896472724309:web:6bfcb7b3bb583eb08135dc",
    measurementId: "G-57RF4M3PM5"
  },
  ADMIN_PEER_ID: 'SuperSee',
  peerjs: {
    host: "signal.raoinfo.tech",
    port: 0,
    path: "/",
    secure: true,
    key: ""
  },
  api: {
    baseUrl: "http://127.0.0.1:8080/wp-json/",
    uploadProfileImageUrl: "http://127.0.0.1:8080/wp-json/",
    baseMediaUrl: "http://127.0.0.1:8080/",
    payment_username: "ck_e650b23aa139aa69c55feaf3788a3b246aeae6ed",
    payment_password: "cs_b3b58e654ee948b092ff797e7834d696326e73fd",
    signUp_username: "test",
    signUp_password: "test",
    razor_pay_key: "test",
    setLimitsForNotifyUsers: 15,
    feedBackSheet: "",
    import_employee_sample: ""
  },
  reCaptchaV3 : {
    site_key: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"
  },
  app: {
    macInstallerUrl: "",
    linuxInstallerUrl: "",
    conductUrl: "",
    rustAgentWindowsInstallerUrl: "http://127.0.0.1:8080/downloads/SuperSee-LocalDev-Setup.exe",
    rustAgentBetaEnabled: true,
    rustAgentBetaBadgeEnabled: true,
    rustAgentWindowsMsiEnabled: true,
    rustAgentWindowsMsiEmployeeUrl: "",
    rustAgentWindowsMsiAdminUrl: "",
    rustAgentWindowsMsiHiddenUrl: "",
    // Activation Journey (goal â†’ private test â†’ proof). Local/staging only until proven.
    activationJourneyEnabled: true
  },
  support: {
    phone: "+91 9016310001",
    whatsapp: "916354719703"
  }
};
